import React, { createContext, useContext, useMemo, useState } from "react";
import { todayETDate } from "@/lib/time";

const DateContext = createContext(null);

export function DateProvider({ children }) {
    const [date, setDate] = useState(todayETDate());
    const value = useMemo(() => ({ date, setDate }), [date]);
    return <DateContext.Provider value={value}>{children}</DateContext.Provider>;
}

export function useSelectedDate() {
    const ctx = useContext(DateContext);
    if (!ctx) throw new Error("useSelectedDate must be used within DateProvider");
    return ctx;
}
